import { render, staticRenderFns } from "./CreateSoundGroupPopup.vue?vue&type=template&id=554351c6&scoped=true"
import script from "./CreateSoundGroupPopup.vue?vue&type=script&lang=ts"
export * from "./CreateSoundGroupPopup.vue?vue&type=script&lang=ts"
import style0 from "./CreateSoundGroupPopup.vue?vue&type=style&index=0&id=554351c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554351c6",
  null
  
)

export default component.exports